import { AuthManagerChangePasswordType, IChangePasswordParams, ICheckLoginParams, ILoginCredentials } from "@multiweb/clients/auth";
import { CancellationToken } from "Global/Base/Promises/CancellationTokenSource";

/**
 * IAuthManager definuje rozhraní metod zajišťujících proces přihlášení.
 * @includeToDoc
 */
export interface IAuthManager {

    /**
     * Změní heslo uživateli.
     * @param changePasswordParams Údaje potřebné ke změne hesla
     * @param cancellationToken Token k přerušení operace
     */
    changePassword(changePasswordParams: IChangePasswordParams, cancellationToken?: CancellationToken): Promise<AuthManagerChangePasswordType>;

    /**
     * Uvěřuje stav přihlášení aktuálního uživatele.
     * @param params Parametry operace kontroly
     * @param cancellationToken Token k přerušení operace
     */
    checkLogin(checkLogonParams: ICheckLoginParams, cancellationToken?: CancellationToken): Promise<boolean>;

    /**
     * Přesměruje na stránku určenou k přihlašování nebo přímo do aplikace, pokud to není potřeba.
     */
    redirectToLoginPage(): Promise<void>;

    /**
     * Provede přihlášení uživatele.
     * @param loginCredentials Údaje potřebné k přihlášení
     * @param winAuth Příznak, zda má být provedeno přihlášení pomocí Windows autentizace
     * @param cancellationToken Token k přerušení operace
     *
     * @throws {TwoFARequiredException} Vyvolá při požadavku na dvoufazovou autentizaci
     */
    login(loginCredentials: ILoginCredentials, winAuth?: boolean, cancellationToken?: CancellationToken): Promise<void>;

    /**
     * Provede anonymní přihlášení
     * @param language Jazyk pro přihlášení
     * @param cancellationToken Token k přerušení operace
     */
    loginAnonymous(language: string, cancellationToken?: CancellationToken): Promise<string>;

    /**
     * Odhlásí uživatele.
     * @param cancellationToken Token k přerušení operace
     */
    logout(cancellationToken?: CancellationToken): Promise<void>;
}

export class IAuthManager {
    private static _methods: Array<keyof IAuthManager> = [
        "changePassword",
        "checkLogin",
        "redirectToLoginPage",
        "login",
        "loginAnonymous",
        "logout"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._methods.some(value => typeof instance[value] !== "function");
    }
}
